import { IMicrositeRecipientImage } from '@nkr/models/index';
import { LightgalleryItem } from 'react-lightgallery';

interface IProps {
    images: IMicrositeRecipientImage[],
    previewImages: any[]
}

const Images = (props: IProps) => {
    return (
        <>
            {props.images.length > 0 && (
                <div className="rotator-container container">
                    <div className="rotator gallery">
                        {props.images.map((image, index) => {
                            const fileName = image.thumbnail || image.fileName;

                            const lightgalleryItemSrc = __NKR_ORG_URL__ + '/microsite/image?filename=' + fileName + '&layout=1';
                            const backgroundImage = __NKR_ORG_URL__ + "/microsite/image?filename=" + fileName + "&layout=2";

                            return (
                                <a key={'image-' + index}>
                                        <div className="rotator-image" style={{ backgroundImage: `url('${backgroundImage}')` }}></div>
                                </a>
                            )
                        })}
                    </div>
                    <button className="siema-prev"><span className="sr-only">Previous slide</span></button>
                    <button className="siema-next"><span className="sr-only">Next slide</span></button>
                </div>
            )}

            {props.previewImages.length > 0 && (
                <div className="rotator-container container">
                    <div className="rotator gallery">
                        {props.previewImages.map((image, index) => {
                            return (
                                <a key={'image-' + index}>
                                    <LightgalleryItem group='any' src={image.thumbnailData} subHtml={'<h3>' + image.caption + '</h3>'}>
                                        <div className="rotator-image" style={{ backgroundImage: "url(" + image.thumbnailData + ")" }}></div>
                                    </LightgalleryItem>
                                </a>
                            );
                        })}
                    </div>
                    <button className="siema-prev"><span className="sr-only">Previous slide</span></button>
                    <button className="siema-next"><span className="sr-only">Next slide</span></button>
                </div>
            )}
        </>
    );
}

export default Images;